/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
import { useWindowSize } from '@brands/hooks';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { Button } from '@mui/material';
import React, { FC, useMemo } from 'react';
import Modal, { Styles } from 'react-modal';

import closeICon from './closeIconSVG.svg';
import styles from './styles.module.scss';

interface InsuranceVerifyModalProps {
  isOpen: boolean;
  hideModal: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      result: string;
    }>
  >;
  verifyResult: string;
}

const mobileCustomStylesDashboard: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...(customStylesDashboard?.overlay || {}),
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    overflowY: 'scroll' as const,
    overflowX: 'hidden' as const,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    ...(customStylesDashboard?.content || {}),
    width: '100vw',
    height: '100vh',
    padding: '90px 16px 32px 16px',
    margin: '0',
    borderRadius: '8px',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
  },
};

const customStylesDashboardDesktop: Styles = {
  ...customStylesDashboard,
  overlay: {
    ...customStylesDashboard.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    position: 'relative',
    padding: '55px 32px 32px',
    borderRadius: '4px',
    minWidth: '444px',
    width: '444px',
    maxHeight: '90vh',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
};
const InsuranceVerifyModal: FC<InsuranceVerifyModalProps> = ({ isOpen, hideModal, verifyResult }) => {
  const screenSize = useWindowSize();
  const isMobile = useMemo(() => screenSize.width < 768, [screenSize.width]);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() =>
        hideModal({
          isOpen: false,
          result: '',
        })
      }
      style={isMobile ? mobileCustomStylesDashboard : customStylesDashboardDesktop}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.closeICon}>
        <img
          src={closeICon}
          onClick={() => {
            hideModal({
              isOpen: false,
              result: '',
            });
          }}
        />
      </div>

      <div className={styles.noServiceContainer}>
        <div className={styles.noServiceContainerHeader}>
          <span className={styles.noServicelHeader}>
            {verifyResult === 'Failed' ? 'We were unable to verify your insurance' : 'We found your insurance!'}
          </span>
          <span className={styles.noServiceContent}>
            {verifyResult === 'Failed'
              ? 'After your visit, we’ll submit a claim to your insurance and let you know if there’s any additional payment required.'
              : 'It looks like your dental plan likely covers the service you selected. After your visit, your insurance will process the claim and determine if there’s any remaining balance from a copay or deductible.'}
          </span>
        </div>

        <div className={styles.insuranceModalButtons}>
          <Button
            type="submit"
            variant="contained"
            className={styles.save}
            color="primary"
            data-testid="unsaved-change-modal-save-changes"
            onClick={() =>
              hideModal({
                isOpen: false,
                result: '',
              })
            }
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

Modal.setAppElement('#root');

export default InsuranceVerifyModal;
